import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
	button: {
		width: "40px",
		height: "40px",
		maxWidth: "unset",
		...shorthands.borderRadius("50%"),
		color: tokens.colorNeutralBackground1,

		"&:hover, &:hover:active": {
			color: tokens.colorNeutralBackground1,
		},
	},

	acceptButton: {
		backgroundColor: tokens.colorNeutralForeground2BrandHover,
		...shorthands.borderColor(tokens.colorNeutralForeground2BrandHover),

		"&:hover, &:hover:active": {
			backgroundColor: tokens.colorNeutralForeground2BrandPressed,
			...shorthands.borderColor(tokens.colorNeutralForeground2BrandPressed),
		},
	},

	rejectButton: {
		backgroundColor: tokens.colorPaletteRedForeground1,
		...shorthands.borderColor(tokens.colorPaletteRedForeground1),

		"&:hover, &:hover:active": {
			backgroundColor: tokens.colorPaletteRedForeground2,
			...shorthands.borderColor(tokens.colorPaletteRedForeground2),
		},
	},
});
